// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.videoTag {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
  object-fit: cover;
}

.container-world {
  background-size: cover;
  color: #fff;
  position: relative;
}
.container-world div {
  padding-top: 50px;
  padding-right: 41%;
  padding-left: 4%;
  padding-bottom: 165px;
  position: relative;
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0) 100%);
}
@media screen and (max-width: 415px) {
  .container-world div {
    padding-left: 7%;
    max-width: 100%;
    padding-right: 0%;
  }
}
@media screen and (max-width: 768px) {
  .container-world div {
    padding-top: 0px;
    padding-right: 30%;
    padding-left: 3.5%;
    padding-bottom: 90px;
  }
}
.container-about {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0% 19.5%;
  margin-top: -62px;
}
@media screen and (max-width: 768px) {
  .container-about {
    padding: 5% 19%;
  }
}
@media screen and (max-width: 535px) {
  .container-about {
    margin-top: -12px;
  }
}
@media screen and (max-width: 415px) {
  .container-about {
    padding: 0% 7%;
    margin-top: 10px;
  }
}
.container-about .desc {
  font-size: 18px;
  font-weight: 400;
  line-height: 27px;
  text-align: center;
}
@media screen and (max-width: 415px) {
  .container-about .desc {
    font-size: 14px;
    line-height: 21px;
  }
}

.world_desc {
  font-size: 18px;
  font-weight: 400;
  line-height: 27px;
  letter-spacing: 0em;
  margin: 45px 0px;
  max-width: 68%;
}
@media screen and (max-width: 768px) {
  .world_desc {
    max-width: 105%;
    width: 105%;
    margin: 30px 0px 25px;
  }
}
@media screen and (max-width: 415px) {
  .world_desc {
    width: 100%;
    font-size: 14px;
    line-height: 21px;
  }
}
.world_title {
  font-size: 64px;
  font-weight: 700;
  line-height: 70px;
  letter-spacing: 0em;
}
@media screen and (max-width: 768px) {
  .world_title {
    font-size: 44px;
    line-height: 66px;
    margin-top: 0px;
  }
}
@media screen and (max-width: 415px) {
  .world_title {
    font-size: 36px;
    line-height: 43.2px;
    margin-bottom: 30px;
  }
}

.demirorenmedya-img {
  width: 100%;
  height: auto;
  object-fit: contain;
  margin-top: 20px;
}`, "",{"version":3,"sources":["webpack://./src/pages/styles/Home.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;AACJ;;AAGI;EACI,sBAAA;EACA,WAAA;EACA,kBAAA;AAAR;AAEQ;EACI,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gFAAA;AAAZ;AAEY;EARJ;IASQ,gBAAA;IACA,eAAA;IACA,iBAAA;EACd;AACF;AACY;EAdJ;IAeQ,gBAAA;IACA,kBAAA;IACA,kBAAA;IACA,oBAAA;EAEd;AACF;AAGI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;AADR;AAGQ;EAPJ;IAQQ,eAAA;EAAV;AACF;AAEQ;EAXJ;IAYQ,iBAAA;EACV;AACF;AACQ;EAfJ;IAgBQ,cAAA;IACA,gBAAA;EAEV;AACF;AAAQ;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAEZ;AAAY;EANJ;IAOQ,eAAA;IACA,iBAAA;EAGd;AACF;;AAKI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AAFR;AAIQ;EARJ;IASQ,eAAA;IACA,WAAA;IACA,qBAAA;EADV;AACF;AAGQ;EAdJ;IAeQ,WAAA;IACA,eAAA;IACA,iBAAA;EAAV;AACF;AAGI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AADR;AAGQ;EANJ;IAOQ,eAAA;IACA,iBAAA;IACA,eAAA;EAAV;AACF;AAEQ;EAZJ;IAaQ,eAAA;IACA,mBAAA;IACA,mBAAA;EACV;AACF;;AAGA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;AAAJ","sourcesContent":[".videoTag {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n    object-fit: cover;\n}\n\n.container {\n    &-world {\n        background-size: cover;\n        color: #fff;\n        position: relative;\n\n        div {\n            padding-top: 50px;\n            padding-right: 41%;\n            padding-left: 4%;\n            padding-bottom: 165px;\n            position: relative;\n            background: linear-gradient(90deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0) 100%);\n\n            @media screen and (max-width: 415px) {\n                padding-left: 7%;\n                max-width: 100%;\n                padding-right: 0%;\n            }\n\n            @media screen and (max-width: 768px) {\n                padding-top: 0px;\n                padding-right: 30%;\n                padding-left: 3.5%;\n                padding-bottom: 90px;\n            }\n\n        }\n    }\n\n    &-about {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        padding: 0% 19.5%;\n        margin-top: -62px;\n\n        @media screen and (max-width: 768px) {\n            padding: 5% 19%;\n        }\n\n        @media screen and (max-width: 535px) {\n            margin-top: -12px;\n        }\n\n        @media screen and (max-width: 415px) {\n            padding: 0% 7%;\n            margin-top: 10px;\n        }\n\n        .desc {\n            font-size: 18px;\n            font-weight: 400;\n            line-height: 27px;\n            text-align: center;\n\n            @media screen and (max-width: 415px) {\n                font-size: 14px;\n                line-height: 21px;\n            }\n\n        }\n    }\n\n}\n\n.world {\n    &_desc {\n        font-size: 18px;\n        font-weight: 400;\n        line-height: 27px;\n        letter-spacing: 0em;\n        margin: 45px 0px;\n        max-width: 68%;\n\n        @media screen and (max-width: 768px) {\n            max-width: 105%;\n            width: 105%;\n            margin: 30px 0px 25px;\n        }\n\n        @media screen and (max-width: 415px) {\n            width: 100%;\n            font-size: 14px;\n            line-height: 21px;\n        }\n    }\n\n    &_title {\n        font-size: 64px;\n        font-weight: 700;\n        line-height: 70px;\n        letter-spacing: 0em;\n\n        @media screen and (max-width: 768px) {\n            font-size: 44px;\n            line-height: 66px;\n            margin-top: 0px;\n        }\n\n        @media screen and (max-width: 415px) {\n            font-size: 36px;\n            line-height: 43.2px;\n            margin-bottom: 30px\n        }\n    }\n}\n\n.demirorenmedya-img {\n    width: 100%;\n    height: auto;\n    object-fit: contain;\n    margin-top: 20px;\n}\n\n// .server-cont {\n//     background: url(\"../../assets/images/server.png\") no-repeat center;\n//     background-size: cover;\n//     padding: 10px;\n// }\n\n// .services {\n//     &-container h4 {\n//         font-size: 64px;\n//         font-weight: 700;\n//         line-height: 70px;\n//         letter-spacing: 0em;\n//         text-align: center;\n//     }\n\n//     &-top {\n//         margin: 2% 11%;\n//         border: 1px solid #fff;\n//         border-radius: 40px;\n//         display: flex;\n//         justify-content: space-around;\n//         height: 245px;\n//         align-items: center;\n//         backdrop-filter: blur(4px);\n//         background: rgba(0, 0, 0, 0.2);\n//     }\n\n//     &-part {\n//         display: flex;\n//         flex-direction: column;\n//         align-items: center;\n//     }\n// }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
